'use client'

import { useTranslations } from 'next-intl'
import styles from '../index.module.scss'

export default function AgeRestrict({
  transKey,
  onMore,
}: {
  transKey: 'adult' | 'child' | 'child-hh'
  onMore?: () => void
}) {
  const t = useTranslations('booking')

  return (
    <div className={styles.ageRestrict}>
      <span className={styles.ageApply}>{t('ticket.selectQuantity.ageRestrict.apply')}</span>
      <span> - </span>

      {t.rich(`ticket.selectQuantity.ageRestrict.${transKey}`, {
        bold: (chunks) => <strong>{chunks}</strong>,
      })}

      {onMore ? (
        <>
          <br />
          {t.rich('ticket.selectQuantity.ageRestrict.more', {
            button: (chunks) => (
              <button type="button" onClick={onMore} className={styles.ageRestrictLink}>
                {chunks}
              </button>
            ),
          })}
        </>
      ) : null}
    </div>
  )
}
